import { Component, EventEmitter, Output, Input } from '@angular/core';
import { QuoteTemplate } from '@app/cp/shared/models/QuoteTemplate';
import { Subscription } from 'rxjs';
import { BaseMessageInfo } from '../../shared/models/BaseMessageInfo';
import { QuoteService } from '../../shared/services/quote.service';

@Component({
    selector: 'quote-template-save',
    templateUrl: './quote-template-save.component.html',
    styleUrls: ['./quote-template-save.component.scss']
})
export class QuoteTemplateSaveComponent  {
    svc_data: QuoteService;
    subs_save: Subscription;
    cpLoaderModal: boolean = false;
    cpLoaderSize = 'md';
    constructor(svc_data: QuoteService) {
        this.data = new QuoteTemplate();
        this.data.IsActive = true;
        this.svc_data = svc_data
    }
    @Output() saveData: EventEmitter<QuoteTemplate> = new EventEmitter<QuoteTemplate>(); 
    @Output() saveError: EventEmitter<String> = new EventEmitter<String>(); 
    @Input() QuoteId: string;
    isLoading = false;
    active: boolean = false;
    data: QuoteTemplate;

    show() {
        this.data = new QuoteTemplate(); 
        this.data.IsActive = true;
        this.active = true;
    }
    hide() {
        this.active = false;
    }
    save()
    {
        this.isLoading = true;
        this.data.QuoteId = this.QuoteId;
        this.subs_save = this.svc_data.saveQuoteTemplate(this.data).subscribe((data: BaseMessageInfo) => {
            this.isLoading = false;
            if (!data.saveError) {
                this.saveData.emit(this.data);
                this.hide();
            }
            else {
                this.saveError.emit(data.message);
            }
    
            this.hide();
        })
    }
    quoteTemplateSave: boolean = false;
    doQuoteTemplateSearch() {
        this.quoteTemplateSave = true;
    }
    quoteTemplateSelected(value: any) {
        this.quoteTemplateSave = false;
        if (value != null) {
//            let busObj: QuoteTemplate = new QuoteTemplate(value);
            this.data = new QuoteTemplate(value);
        }
    }
}

